<div class="main">
    <div class="divmain">
        <nz-tag nzColor="blue">{{pedido.companyname}}</nz-tag>
        <nz-tag nzColor="purple">{{pedido.pedido}}</nz-tag>
        <nz-tag nzColor="cyan">{{pedido.MktpName}}</nz-tag>
        <nz-tag nzColor="geekblue">{{'pushpedidos.internalid'|translateTA}}: {{pedido.internalid}}</nz-tag>
        <nz-tag nzColor="orange" [nz-tooltip]="pedido.mensagem" [class.tag-error]="error">{{'pushpedidos.status'|translateTA}}: {{pedido.status}}</nz-tag>
        <nz-tag nzColor="green">{{'pushpedidos.order'|translateTA}}: {{pedido.erpOrder}}</nz-tag>
    </div>
    <div class="divmain2">
        <div class="divmainitem">
            <nz-icon nzType="login" nzTheme="outline" nz-tooltip [nzTooltipTitle]="'pushpedidos.step1'|translateTA"
                     [class.step-off]="step1Disabled && !finished" [class.step-error]="error"></nz-icon>
            <nz-progress [nzPercent]="step1Disabled? 0 :  finished ? 100 : 50" [nzStatus]="error ? 'exception' : 'active'" nzShowInfo="false"></nz-progress>
        </div>
        <div class="divmainitem">
            <nz-icon nzType="filter" nzTheme="outline" nz-tooltip [nzTooltipTitle]="'pushpedidos.step2'|translateTA"
                     [class.step-off]="step2Disabled && !finished" [class.step-error]="error"></nz-icon>
            <nz-progress [nzPercent]="step2Disabled? 0 :  finished ? 100 : 50" [nzStatus]="error ? 'exception' : 'active'" nzShowInfo="false"></nz-progress>
        </div>
        <div class="divmainitem">
            <nz-icon nzType="dollar" nzTheme="outline" nz-tooltip [nzTooltipTitle]="'pushpedidos.step3'|translateTA"
                     [class.step-off]="step3Disabled && !finished" [class.step-error]="error"></nz-icon>
            <nz-progress [nzPercent]="step3Disabled?0: finished ? 100 : 50" [nzStatus]="error ? 'exception' : 'active'" nzShowInfo="false"></nz-progress>
        </div>
        <div class="divmainitem">
            <nz-icon nzType="smile" nzTheme="outline" nz-tooltip [nzTooltipTitle]="'pushpedidos.step4'|translateTA"
                     [class.step-off]="step4Disabled && !finished" [class.step-error]="error"></nz-icon>
            <nz-progress [nzPercent]="step4Disabled? 0 :  finished ? 100 : 50" [nzStatus]="error ? 'exception' : 'active'" nzShowInfo="false"></nz-progress>
        </div>
        <div class="divmainitem">
            <nz-icon nzType="check" nzTheme="outline" nz-tooltip [nzTooltipTitle]="'pushpedidos.step5'|translateTA"
                     [class.step-off]="!finished" [class.step-error]="error"></nz-icon>
        </div>
    </div>
</div>
